export const makeMessage = (type, data) => ({
    type,
    payload: data,
    fromAssign: true
});

export const postMessageToParent = data => {
    window.parent.postMessage(data, '*');
};

export const toLotData = (lot, idx) => ({
    name: lot.name,
    id: lot.id,
    variant: 'lot',
    title: 'Lot',
    num: idx + 1,
    lotNum: idx + 1,
    suppliers: lot.suppliers
});

export const toItemData = (item, idx, lotIdx) => {
    let itemName = item.item_name;
    if ('lot_name' in item) {
        // Given lot with bid action 3
        // supplier only gives a response of lot, doesn't provide for line-items
        // 
        // In this case only one line item is allowed, and that has `lot_name`
        // attribute instead of `item_name` to show name of line item
        itemName = item.lot_name
    }
    return ({
        name: itemName,
        id: item.urid,
        num: idx + 1,
        lotNum: lotIdx + 1,
        variant: 'line_item',
        title: 'Item'
    })
};

export const cleanThePrice = (ceilingPrice, localeCode) => {
    if (ceilingPrice.charAt(0) === '.')
        ceilingPrice = '0' + ceilingPrice.substring(0);
    try {
        let value = ceilingPrice.replace(/^\D+/g, '');
        value = value.replace(/,/g, '');
        value = parseFloat(value);

        if (value) {
            const formatter = new Intl.NumberFormat(localeCode, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
            return formatter.format(value);
        } else {
            value = '';
        }
        return value;
    } catch (e) {}
};
